module.exports = __webpack_public_path__ + "static/img/app-info-demo-1@2x.d4ea61a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app-info-demo-1@2x.png
// module id = uM6X
// module chunks = 1